import script from "./TestEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TestEditor.vue?vue&type=script&setup=true&lang=js"

import "./TestEditor.vue?vue&type=style&index=0&id=36db3868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36db3868"]])

export default __exports__